import { createProvideInject } from '@collector/shared-ui'

import { PitchBlockedEventStatus } from '../configuration'

export const [providePitchBlockedEventStatus, injectPitchBlockedEventStatus] =
  createProvideInject<PitchBlockedEventStatus>('pitchBlockedEventStatus')
